import type { PDFWriter } from "@pdfking/renderer-api"

export const CreatePDFWriter = (): Promise<PDFWriter> =>
  import("../utils/Proxy").then(({ CreatePDFWriter }) => CreatePDFWriter())
